import { useApolloClient, useQuery } from '@apollo/client';

import { GET_USER_SPONSOR } from '@pass-frontend/common/data-access';
import { Sponsor } from '@pass-frontend/data-access/common/edge';

const KAISER_HAWAII_SPONSOR_IDS = [
  'optumv2_kp_hi_commercial_3',
  'optumv2_kp_hi_commercial_1',
  'optumv2_kp_hi_commercial_2',
  'optumv2_kp_hi_commercial_4',
];

const KAISER_COLORADO_SPONSOR_IDS = ['optumv2_kp_co_commercial_1'];

export const useCurrentSponsor = () => {
  const client = useApolloClient();

  const result = client.readQuery({
    query: GET_USER_SPONSOR,
  });

  const { loading, data, error, startPolling, stopPolling } = useQuery<{
    currentSponsor: Sponsor;
  }>(GET_USER_SPONSOR, {
    fetchPolicy: 'cache-only',
  });

  const { currentSponsor } = result || data || {};

  const isKaiserHawaii = KAISER_HAWAII_SPONSOR_IDS.includes(
    currentSponsor?.sponsorId || '',
  );

  const isKaiserColorado = KAISER_COLORADO_SPONSOR_IDS.includes(
    currentSponsor?.sponsorId || '',
  );

  return {
    currentSponsor,
    error,
    loading,
    startPolling,
    stopPolling,
    isKaiserHawaii,
    isKaiserColorado,
  };
};
